import React from 'react';
import IcoMoon from 'react-icomoon';
import PropTypes from 'prop-types';

import { WithTooltip } from '../Elements';

import classes from './ProcessIcons.module.scss';
const iconSet = require('data/processIcons.json');

const ProcessIcons = ({ text, ...props }) => {
  return (
    <WithTooltip text={text} className={classes.tooltip}>
      <div className={classes.icon_wrap}>
        <IcoMoon iconSet={iconSet} {...props} className={classes.icon} />
      </div>
    </WithTooltip>
  );
};

ProcessIcons.propTypes = {
  text: PropTypes.string.isRequired
};

export default ProcessIcons;
